// 5ca32b4227c31aeba6924137877016d026808342|name=ChatMessage|schemaHash=678011f923cda9a4772cef79a8ad4d0368571c80|kind=parser-js

import { checkDate } from '@myre/common-dates';
import { setDefinedValue } from '@myre/common-primitives';

export function parseChatMessageFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'timestamp', checkDate(_data.timestamp));
  setDefinedValue(result, 'uuid', _data.uuid);
  setDefinedValue(result, 'sessionId', _data.sessionId);
  setDefinedValue(result, 'status', _data.status);
  setDefinedValue(result, 'errorDetails', _data.errorDetails);
  setDefinedValue(result, 'userRating', _data.userRating);
  setDefinedValue(result, 'userFeedback', _data.userFeedback);
  setDefinedValue(result, 'role', _data.role);
  setDefinedValue(result, 'content', _data.content);
  setDefinedValue(result, 'url', _data.url);
  setDefinedValue(result, 'moduleNames', _data.moduleNames);
  setDefinedValue(result, 'contextParams', _data.contextParams);
  setDefinedValue(result, 'queryParams', _data.queryParams);
  setDefinedValue(result, 'mode', _data.mode);
  setDefinedValue(result, 'langLocale', _data.langLocale);
  setDefinedValue(result, 'files', _data.files);
  setDefinedValue(result, 'parts', _data.parts);
  setDefinedValue(result, 'displayLabel', _data.displayLabel);
  setDefinedValue(result, 'enabledTools', _data.enabledTools);
  setDefinedValue(result, 'disabledTools', _data.disabledTools);

  return result;
}

export function parseChatMessageToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'timestamp', _data.timestamp instanceof Date ? _data.timestamp.toISOString() : _data.timestamp);
  setDefinedValue(result, 'uuid', _data.uuid);
  setDefinedValue(result, 'sessionId', _data.sessionId);
  setDefinedValue(result, 'status', _data.status);
  setDefinedValue(result, 'errorDetails', _data.errorDetails);
  setDefinedValue(result, 'userRating', _data.userRating);
  setDefinedValue(result, 'userFeedback', _data.userFeedback);
  setDefinedValue(result, 'role', _data.role);
  setDefinedValue(result, 'content', _data.content);
  setDefinedValue(result, 'url', _data.url);
  setDefinedValue(result, 'moduleNames', _data.moduleNames);
  setDefinedValue(result, 'contextParams', _data.contextParams);
  setDefinedValue(result, 'queryParams', _data.queryParams);
  setDefinedValue(result, 'mode', _data.mode);
  setDefinedValue(result, 'langLocale', _data.langLocale);
  setDefinedValue(result, 'files', _data.files);
  setDefinedValue(result, 'parts', _data.parts);
  setDefinedValue(result, 'displayLabel', _data.displayLabel);
  setDefinedValue(result, 'enabledTools', _data.enabledTools);
  setDefinedValue(result, 'disabledTools', _data.disabledTools);

  return result;
}
